export default "__VITE_ASSET__Cqxl461J__"